import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import React, { FC } from "react";
import { COLOR_GREY_11, COLOR_PRIMARY_MAIN } from "shared/theme/colors";
import { GameMetadataTabsEnum } from "../../context/types";
import { useMetadata } from "../../stores/useMetadata";
import { StyledMetadataTab, StyledMetadataTabs } from "./styled";
import GameInformation from "./tabs/GameInformation";
import GeneralMetadata from "./tabs/GeneralMetadata";

const Metadata: FC = () => {
  const { metadataTab, setMetadataTab } = useMetadata();

  const handleChangeMetadataTab = (value: GameMetadataTabsEnum) => {
    setMetadataTab(value);
  };

  return (
    <Stack spacing="1rem">
      <StyledMetadataTabs>
        {Object.values(GameMetadataTabsEnum).map((tab, index) => (
          <StyledMetadataTab
            key={tab}
            id={String(index)}
            isActive={tab === metadataTab}
            onClick={() => handleChangeMetadataTab(tab)}
          >
            <Typography
              variant="bodyMMedium"
              color={tab === metadataTab ? COLOR_PRIMARY_MAIN : COLOR_GREY_11}
            >
              {tab}
            </Typography>
          </StyledMetadataTab>
        ))}
      </StyledMetadataTabs>

      {metadataTab === GameMetadataTabsEnum.GENERAL && <GeneralMetadata />}
      {metadataTab === GameMetadataTabsEnum.GAME_INFORMATION && (
        <GameInformation />
      )}
    </Stack>
  );
};

export default Metadata;
